import { Button, TableColumnsType } from 'antd';
import ScrollTable, { ScrollTableProps } from 'components/ScrollTable';
import dayjs from 'lib/dayjs';
import { formatNumber } from 'utils/numberFormat';
import { useTranslate } from '@tolgee/react';

type RT = AeOverview.BuyerSummary;

export interface BuyerRecordTableProps extends ScrollTableProps<RT> {
  onCheckDetail: (record: RT) => void;
}

function BuyerRecordTable(props: BuyerRecordTableProps) {
  const { onCheckDetail, ...otherProps } = props;

  const { t } = useTranslate();

  const columns: TableColumnsType<RT> = [
    {
      key: 'buyerNick',
      dataIndex: 'buyerNick',
      title: t('marketing.买家昵称'),
      width: 160,
    },
    {
      key: 'lastSendTime',
      dataIndex: 'lastSendTime',
      title: t('aeoverview.最后AI服务时间'),
      width: 160,
      render: (lastSendTime: RT['lastSendTime']) =>
        dayjs(Number(lastSendTime)).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'sentNum',
      dataIndex: 'sentNum',
      title: t('aeoverview.下发条数'),
      width: 160,
      render: (sentNum: RT['sentNum']) => formatNumber(sentNum, '0,0'),
    },
    {
      key: 'operation',
      title: t('操作'),
      width: 160,
      render: (_, record) => (
        <Button type="link" onClick={() => onCheckDetail(record)} style={{ paddingLeft: 0 }}>
          {t('marketing.查看明细')}
        </Button>
      ),
    },
  ];

  return <ScrollTable rowKey="buyerId" columns={columns} {...otherProps} />;
}

export default BuyerRecordTable;
